import DealPercentageOff from './DealPercentageOff';
export default DealPercentageOff;